// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__3Vq_y","cardHeader":"Card_cardHeader__16XgI","content":"Card_content__1a7eK"};